import React from 'react'
import classNames from 'classnames'
import './index.css'

const ButtonTextPrimary = React.forwardRef(function ButtonTextPrimary (props, ref) {
  const {
    children,
    ...rest
  } = props

  let { className } = props
  className = classNames(className, {
    'button-text-primary': true
  })

  return (
    <button {...rest} ref={ref} className={className}>
      {children}
    </button>
  )
})

export default ButtonTextPrimary
